<div class="container-fluid no-gutters">
  <div class="d-flex align-items-center justify-content-between">
    <h2 class="title">{{isEdit ? 'Edit News' : 'Add News'}}</h2>
    <button class="btn btn-add button btn-primary btn-vernova" (click)="submit()">Save</button>
  </div>
  <div [formGroup]="formGroup" class="mt-2">
    <div class="w-100">
      <mat-form-field appearance="outline" class=" w-100">
        <input matInput required formControlName="title" maxlength="100" placeholder="Enter title here">
        <mat-hint align="end">{{formGroup.controls.title.value.length || 0}} / 100</mat-hint>
        <mat-error>{{formGroup.controls.title.errors?.message}}</mat-error>
      </mat-form-field>
      <mat-form-field appearance="outline" class="mt-1 w-100">
        <textarea matInput required formControlName="shortDescription" placeholder="Enter short description here" style="height: 100px;"
        maxlength="512"></textarea>
        <mat-hint align="end">{{formGroup.controls.shortDescription.value?.length}} / 512</mat-hint>
        <mat-error>{{formGroup.controls.shortDescription.errors?.message}}</mat-error>
      </mat-form-field>
    </div>
    <div class="w-100 mt-2">
      <input type="file" #quillFileRef (change)="onSelectFile($event)" hidden />
      <div id="editor" style="height: 500px;"></div>
      <mat-hint align="end" style="float: right; font-size: 75%;">{{quill?.getLength() - 1}} / {{limit}}</mat-hint>
      <mat-error style="font-size: 75%" *ngIf="isContent">This field is required</mat-error>
    </div>
  </div>
</div>